<form (ngSubmit)="continue()" class="ui-kit-rows-layout">
  <tax-input
    [required]="true"
    labelText="retailPlace.vpn.responsible.person"
    id="owner"
    name="owner"
    type="text"
    placeholder="user.form.initials"
    [tabindex]="1"
    [autofocus]="true"
    [(ngModel)]="retailPlaceData.responsiblePerson"
    [clearable]="true"
    [layoutColumns]="2"
    data-qa-input="responsible-person"
  ></tax-input>

  <tax-phone-input
    [required]="true"
    [id]="'phone'"
    placeholder="+"
    [(ngModel)]="retailPlaceData.phone"
    name="phone"
    [clearable]="true"
    [layoutColumns]="2"
    [width]="'50%'"
    [tabindex]="2"
    data-qa-input="phone"
  ></tax-phone-input>

  <tax-input
    [required]="true"
    labelText="retailPlace.vpn.kkm.amount"
    id="amount"
    name="amount"
    type="text"
    placeholder="0"
    [maxlength]="10"
    taxNumbersOnly
    [tabindex]="3"
    [(ngModel)]="retailPlaceData.kkmAmount"
    [clearable]="true"
    [layoutColumns]="2"
    data-qa-input="kkm-amount"
  ></tax-input>

  <div class="ui-kit-layout-columns-2" data-qa-input="comment">
    <label for="comment" class="textarea" translate data-qa="label-text"
      >retailPlace.vpn.kkm.comments</label
    >
    <textarea
      class="text_field"
      id="comment"
      name="comment"
      rows="3"
      tabindex="4"
      [(ngModel)]="retailPlaceData.comments"
      data-qa="input"
    ></textarea>
  </div>

  <div class="ui-kit-bottom-buttons-block">
    <button class="back-button" (click)="back()" data-qa-button="go-back" type="button">
      {{ 'group.back' | translate }}
    </button>
    <div>
      <button
        class="button_blue"
        [disabled]="!isFormValid()"
        data-qa-button="go-to-vpn-sign"
        translate
      >
        button.send
      </button>
    </div>
  </div>
</form>
